import { ButtonApply, InputField, Label, PCCInfoApply, PCContainer } from "./PromoCode.styled";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { ChangeEvent, useState } from "react";

interface PromoCodeProps {}

export const PromoCode = observer(({}: PromoCodeProps) => {
	const { t } = useTranslation();
	const { promoCodeStore, authStore, notificationsStore } = useStores();
	const [currentPromoCode, setCurrentPromoCode] = useState("");

	const handleOnChangePromoCode = (e: ChangeEvent<HTMLInputElement>) => {
		const { value } = e.currentTarget;
		setCurrentPromoCode(value);
	};

	const handleOnApplyPromoCode = async () => {
		if (!authStore.isAuth) {
			notificationsStore.error({
				message: t("notifications.message.promoCodeNoAuth"),
			});
			return;
		}

		await promoCodeStore.apply(currentPromoCode);
	};

	return (
		<PCContainer>
			<Label>{t("labels.promo_code")}</Label>
			<InputField onChange={handleOnChangePromoCode} />
			<ButtonApply onClick={handleOnApplyPromoCode}>+</ButtonApply>

			{promoCodeStore.isActive && <PCCInfoApply>{t("notifications.titles.promoCodeApply")}</PCCInfoApply>}
		</PCContainer>
	);
});
